export const selectStudios = (state) => state.studios.studios;

export const selectStudio = (state) => state.studios.studio;
